
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

export default function Testimonials() {
  const { t, i18n } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  const koreanTestimonials = [
    {
      text: "QR 코드로 메뉴판을 디지털화했는데 고객들이 너무 편해해요. 주문도 빨라지고 관리도 쉬워졌어요.",
      author: "익명의 레스토랑 운영자",
      location: "서울",
      rating: 5
    },
    {
      text: "카페 인스타그램과 메뉴를 하나의 QR로 연결했더니 팔로워도 늘고 매출도 올랐어요.",
      author: "익명의 카페 사장님", 
      location: "부산",
      rating: 5
    },
    {
      text: "온라인 쇼핑몰 링크들을 정리해서 고객들이 쉽게 찾을 수 있게 됐어요. 정말 유용해요.",
      author: "익명의 쇼핑몰 운영자",
      location: "대구",
      rating: 5
    },
    {
      text: "헬스장 회원들이 운동 프로그램과 스케줄을 QR로 쉽게 확인할 수 있어서 만족도가 높아졌어요.",
      author: "익명의 헬스장 관장님",
      location: "인천",
      rating: 5
    }
  ];

  const englishTestimonials = [
    {
      text: "Switched to QR menus for our restaurant and customers love the convenience. Orders are faster and management is so much easier.",
      author: "Anonymous Restaurant Owner",
      location: "New York",
      rating: 5
    },
    {
      text: "Perfect for managing all our social media and booking links in one place. Our marketing campaigns are much more effective now.",
      author: "Anonymous Marketing Manager",
      location: "Singapore",
      rating: 5
    },
    {
      text: "Event attendees can easily access all our information with just one scan. Makes networking events so much smoother.",
      author: "Anonymous Event Organizer",
      location: "Barcelona",
      rating: 5
    },
    {
      text: "Simple, clean interface that does exactly what we need. The analytics help us understand our customer engagement better.",
      author: "Anonymous Business Owner",
      location: "London",
      rating: 5
    }
  ];

  const testimonials = i18n.language === 'ko' ? koreanTestimonials : englishTestimonials;

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-teal-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('testimonials.title')}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">{t('testimonials.subtitle')}</p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="overflow-hidden rounded-2xl bg-white shadow-xl">
            <div className="flex transition-transform duration-500 ease-in-out" 
                 style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full flex-shrink-0 p-12 text-center">
                  <div className="flex justify-center mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-2xl"></i>
                    ))}
                  </div>
                  <blockquote className="text-xl text-gray-700 mb-8 leading-relaxed italic">
                    "{testimonial.text}"
                  </blockquote>
                  <div>
                    <div className="font-semibold text-gray-900 text-lg">{testimonial.author}</div>
                    <div className="text-gray-500">{testimonial.location}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center mt-8 space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  currentSlide === index ? 'bg-teal-600' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
